import { makeStyles } from '@material-ui/core'

// Espessura do traço luminoso (fino) que percorre a borda externa.
const STROKE = 2

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.white,
    border: `1px solid ${theme.palette.dai.light}`,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  // SVG deslocado para fora do banner (metade do traço) para o stroke assentar
  // totalmente na parte externa da borda.
  svg: {
    position: 'absolute',
    top: -STROKE / 2,
    left: -STROKE / 2,
    width: `calc(100% + ${STROKE}px)`,
    height: `calc(100% + ${STROKE}px)`,
    overflow: 'visible',
    pointerEvents: 'none',
    zIndex: 0,
  },
  comet: {
    fill: 'none',
    stroke: theme.palette.dai.shinyBlue,
    strokeWidth: STROKE,
    strokeLinecap: 'round',
    rx: theme.shape.borderRadius + STROKE / 2,
    ry: theme.shape.borderRadius + STROKE / 2,
    filter: `drop-shadow(0 0 ${STROKE}px ${theme.palette.dai.glow})`,
    opacity: 0.8,
    transition: 'opacity 400ms ease',
  },
  border: {
    fill: 'none',
    stroke: theme.palette.dai.shinyBlue,
    strokeWidth: STROKE,
    rx: theme.shape.borderRadius + STROKE / 2,
    ry: theme.shape.borderRadius + STROKE / 2,
    filter: `drop-shadow(0 0 ${STROKE}px ${theme.palette.dai.glow})`,
    opacity: 0,
    transition: 'opacity 400ms ease',
  },
  hidden: {
    opacity: 0,
  },
  shown: {
    opacity: 0.5,
  },
  content: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: 1,
    minWidth: 0,
  },
  message: {
    color: theme.palette.dai.shinyBlue,
    fontWeight: 500,
  },
  action: {
    position: 'relative',
    zIndex: 1,
    flexShrink: 0,
    '& button': {
      whiteSpace: 'nowrap',
    },
  },
}))

export default useStyles
